import getConfig from "next/config";
import { i18n } from "@lib/i18n";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { getLanguageCode } from "@shared/v2/lib/getLanguageCode";
import { isStaticServiceHostedAsset } from "@shared/v2/lib/isStaticServiceHostedAsset";

const { publicRuntimeConfig } = getConfig();

export const openDocument = documentName => {
  const country = publicRuntimeConfig.COUNTRY;
  const languageCode = getLanguageCode(i18n.language);

  if (!documentName) {
    throw new Error(`Invalid documentName '${documentName}'`);
  }

  if (isStaticServiceHostedAsset(documentName)) {
    return window.open(`${publicRuntimeConfig.STATIC_URL}${documentName}`);
  }

  window.open(
    getStaticAssetURL(`/docs/${country}/${languageCode}/${documentName}`)
  );
};
